import type { Size } from "./types";

export const sizes = ["xs", "sm", "md", "lg"] as const;

export const DEFAULT_SIZE = "md" satisfies Size;
